import configureStore from './store'

export const store = configureStore({})
